import {
	matchHome,
	matchFabricEditor,
	matchSpaceOverview,
	matchViewPage,
	matchLivePage,
	matchCreateContent,
	matchWhiteboardPage,
	matchSearch,
} from '@confluence/query-preloaders-common/entry-points/matchRoutes';
import { waitUntilStatsigInitialized } from '@confluence/statsig-client/entry-points/getSessionDataAndInitializeStatsig';
import { fg } from '@confluence/feature-gating';

import {
	preloadLivePagesComponents,
	preloadViewPageComponents,
	preloadSpaceOverview,
	preloadSearch,
	preloadNativeEditorComponentsPreloader,
	preloadCreateContent,
	preloadWhiteboardPage,
	preloadHome,
} from './preloaders';

/**
 * Preload components/chunks that are required for the critical path of the current route,
 * when they're not preloaded as part of SSR page delivery. This may happen when:
 *  - page is not SSR'ed due to some failure, or
 *  - no SSR enabled for the page
 *
 * Note: This function is called early, check waitUntilStatsigInitialized before using fg()
 */
export const preloadComponentsNoStatsigSupport = async (url, isTransition) => {
	const shouldPreload = isTransition || !window.__SSR_RENDERED__;

	let match;
	if ((match = matchHome(url))) {
		preloadHome(match);
	} else if (matchSpaceOverview(url)) {
		if (shouldPreload) {
			preloadSpaceOverview();
		}
	} else if (matchLivePage(url) && shouldPreload) {
		if (
			(await waitUntilStatsigInitialized()) &&
			fg('confluence_live_page_preload_livepage_route')
		) {
			preloadLivePagesComponents();
		}
	} else if ((match = matchViewPage(url))) {
		if (shouldPreload) {
			preloadViewPageComponents(match);
		}
	} else if (matchFabricEditor(url)) {
		preloadNativeEditorComponentsPreloader();
	} else if (matchCreateContent(url)) {
		preloadCreateContent();
	} else if (matchWhiteboardPage(url)) {
		preloadWhiteboardPage();
	} else if (matchSearch(url)) {
		preloadSearch();
	}
};
